@if(parentFormGroup.get(controlKey)){
<div
  [formGroupName]="controlKey"
  [ngClass]="[
    layout === 'horizontal'
      ? 'flex flex-row gap-2 w-full'
      : 'flex flex-col gap-4 w-full',
    containerClassNames
  ]"
>
  <div class="flex-1 w-full">
    <otw-form-field
      label="Регион"
      for="region"
      [labelClassNames]="labelColor === 'white' ? 'text-white' : '!text-black'"
      classNames="!w-full"
    >
      @if(inputSize){
      <p-select
        [options]="regions"
        formControlName="region"
        name="region"
        class="w-full"
        [showClear]="true"
        [size]="inputSize"
        [filter]="true"
        [checkmark]="true"
        (onChange)="onRegionChange($event.value)"
      />
      }@else {<p-select
        [options]="regions"
        [filter]="true"
        formControlName="region"
        name="region"
        class="w-full"
        [showClear]="true"
        [checkmark]="true"
        (onChange)="onRegionChange($event.value)"
      />}
    </otw-form-field>
  </div>
  <div class="flex-1 w-full">
    <otw-form-field
      label="Населено място"
      for="city"
      [labelClassNames]="labelColor === 'white' ? 'text-white' : '!text-black'"
      classNames="!w-full"
    >
      @if(inputSize){
      <p-select
        [options]="cities"
        formControlName="city"
        name="city"
        class="w-full"
        [showClear]="true"
        [filter]="true"
        [size]="inputSize"
        [checkmark]="true"
        emptyMessage="Няма намерени населени места в този регион."
      />
      }@else {
      <p-select
        [options]="cities"
        [filter]="true"
        formControlName="city"
        name="city"
        class="w-full"
        [showClear]="true"
        [checkmark]="true"
        emptyMessage="Няма намерени населени места в този регион."
      />
      }
    </otw-form-field>
  </div>
</div>
}
